import { t } from '@lingui/macro';

import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { IP_RULE_FIELD } from '../../ip-form/IpFormConstants';
import { DEVICE_COUNT_FIELD, NOTIFICATIONS_EMAIL_FIELD } from '../sites/SiteAdminConstants';

export const NAME_FIELD = 'name';
export const DESCRIPTION_FIELD = 'description';
export const TAGS_FIELD = 'tags';
export const IP_RULES_FIELD = 'rules';
export const SERVICE_TESTS_FIELD = 'tests';

export const RULES_COLUMNS = [
    {
        type: COLUMN_TYPES.TEXT,
        title: t`IP Scope`,
        sortable: true,
        mapping: IP_RULE_FIELD,
        width: 250,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Description`,
        sortable: true,
        mapping: DESCRIPTION_FIELD,
        width: 250,
    },
    {
        type: COLUMN_TYPES.NUMERIC,
        title: t`Monitored Device Count`,
        sortable: true,
        mapping: DEVICE_COUNT_FIELD,
        width: 210,
    },
];

export function notificationsEmailDataSource(_id) {
    return {
        url: `/ngp/v2/inventory/subscribers/business-services/${_id}`,
        totalProperty: 'count',
        dataProperty: 'data',
        params: {
            searchFields: [NOTIFICATIONS_EMAIL_FIELD],
        },
    };
}
